// SVG chip faces (D6): shape and icon chips show a silhouette drawn from the SAME outlines the
// tag uses (src/icons.js ICON_PATHS), never an emoji. PURE string building — no DOM, no geometry
// imports (icons.js is data-only), so this can be used from the main thread same as icons.js.
import { ICON_PATHS } from '../icons.js';

// Bounding box of a path's raw coordinate pairs (M/L/C/Z only, per icons.js authoring rules: every
// number is part of an (x, y) pair in order, so pairing the flat number list is exact). A superset
// of the true curve bounds for a C — fine for a viewBox, which only needs to not clip the ink.
function pathBounds(d) {
  const nums = (d.match(/-?\d+(\.\d+)?/g) || []).map(Number);
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (let i = 0; i + 1 < nums.length; i += 2) {
    const x = nums[i], y = nums[i + 1];
    if (x < minX) minX = x; if (x > maxX) maxX = x;
    if (y < minY) minY = y; if (y > maxY) maxY = y;
  }
  return { minX, minY, maxX, maxY };
}

// iconId → inline SVG (y-up path, flipped into SVG's y-down space by the matrix transform — the
// same flip modelToSvg/svgToModel use elsewhere, done here on the path itself so no wrapper group
// is needed). viewBox is the fixed 0..1000 box unless the icon's own bounds overflow it (icons.js
// says every icon SHOULD fit 0..1000, but phone's ear/mouth pieces don't — D11).
export function iconSvg(iconId) {
  const d = ICON_PATHS[iconId];
  if (!d) return '';
  const b = pathBounds(d);
  const fits = b.minX >= 0 && b.minY >= 0 && b.maxX <= 1000 && b.maxY <= 1000;
  const vb = fits
    ? '0 0 1000 1000'
    : `${Math.floor(b.minX)} ${Math.floor(1000 - b.maxY)} ${Math.ceil(b.maxX - b.minX)} ${Math.ceil(b.maxY - b.minY)}`;
  return `<svg viewBox="${vb}" aria-hidden="true" focusable="false"><path transform="matrix(1 0 0 -1 0 1000)" d="${d}" fill="currentColor"/></svg>`;
}

// shape → inline SVG. circle is drawn directly (it has no icon outline); bone/heart/paw/cat reuse
// the matching icon path verbatim (cat is the new D11 icon — the shape chip and the icon chip are
// the same silhouette).
export function shapeSvg(shape) {
  if (shape === 'circle') return '<svg viewBox="0 0 1000 1000" aria-hidden="true" focusable="false"><circle cx="500" cy="500" r="460" fill="currentColor"/></svg>';
  return iconSvg(shape);
}
